/*
 * Copyright (c) 2018 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */

import React, {Component} from 'react';
import PropTypes from 'prop-types';

import Select from 'react-select';
import {api} from '../api';
import classnames from './SearchableInstitutionSelector.css';

/**
 * Allows user to select an institution from a pre-defined set of options.
 */
class SearchableInstitutionSelector extends Component {
    static propTypes = {
      onSelect: PropTypes.func.isRequired
    };

    constructor (props) {
      super(props);

      this.state = {
        value: undefined
      };
    }

    render () {
      return (
        <Select.Async
          id="searchable-institution-selector"
          className={classnames.searchableInstitutionSelector}
          valueKey="id"
          labelKey="name"
          aria-label="Searchable Institution Selector"
          clearable={false}
          placeholder=""
          value={this.state.value}
          onChange={this.selectInstitution}
          loadOptions={this.getInstitutions}
          optionRenderer={this.renderOption}
          filterOption={this.filterOption}
        />
      );
    }

    renderOption = (option) => {
      const postalCode = (option.mainAddress  && option.mainAddress.postalCode) || (option.busAddress && option.busAddress.postalCode);

      return (
        <div className={classnames.searchResult}>
          <span className={classnames.optionId}>{option.id}</span>
          <span className={classnames.optionSymbols}><ul>
              {option.symbols && option.symbols.map((symbol)=> {
                  return (<li key={symbol}>{symbol}</li>)
              })}
          </ul></span>
          <span className={classnames.optionPostalCode}>{postalCode}</span>
          <span className={classnames.optionName}>{option.name}</span>
        </div>
      );
    };

    /**
     * Override the default filter method so that all options returned by the server API are returned.  The server
     * already filters the result set, no need to do it twice here.
     *
     * One might wonder why we don't simply use the <Select /> component instead.  The <Select.Async /> component
     * still provides caching that we want to utilize.
     *
     * @param option
     * @param filter
     * @returns {boolean}
     */
    filterOption = (option, filter) => {
      return true;
    };

    /**
     * Asynchronously load the institutions to display in the auto complete box.
     *
     * The decision was made to consider these institutions local state vs. storing the result set in the Redux store.
     * @param input
     * @returns {*}
     */
    getInstitutions = (input) => {
      if (!input) {
        return Promise.resolve({options: [], complete: true});
      } else {
        return api(`api/institutions?q=${encodeURIComponent(input)}`)
          .then(response => response.json())
          .then((json) => {
              for (var key in json) {
                  // Remove null items
                  if (json[key].id === null) {
                      json.splice(key, 1);
                  }
              }
            return { options: json, complete: true };
          });
      }
    };

    /**
     * Select a new institution.
     *
     * @param institution the newly selected institution.
     */
    selectInstitution = (institution) => {
      this.setState({value: institution});
      this.props.onSelect(institution);
    }
}

export default SearchableInstitutionSelector;



// WEBPACK FOOTER //
// ./src/InstitutionPicker/SearchableInstitutionSelector.js